import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box, Typography } from '@mui/material';

/**
 * LogoutHandler Component
 * 
 * Handles logout logic when user navigates to /logout
 * Shows loading state while logging out, then redirects to login
 */
const LogoutHandler = () => {
  const { logout, isAuthenticated } = useAuth();

  useEffect(() => {
    const performLogout = async () => {
      if (isAuthenticated) {
        await logout();
      }
    };

    performLogout();
  }, [logout, isAuthenticated]);

  // If user is not authenticated, redirect to login immediately
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Show loading state while logging out
  return (
    <Box 
      display="flex" 
      flexDirection="column"
      justifyContent="center" 
      alignItems="center" 
      minHeight="400px"
      gap={2}
    >
      <CircularProgress size={48} />
      <Typography variant="h6" color="text.secondary">
        Signing you out...
      </Typography>
    </Box>
  );
};

export default LogoutHandler;